import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
export function BulkActionApprove(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkApprove`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetStepCount(stepId, query, callback) {
  console.log(query);
  axios.get(
    `${Globals.baseUrl}/BulkEdit/GetStepCount/${stepId}`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      callback(result);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetStepCount2(query, callback) {
  console.log(query);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/GetStepCount2`,
    query,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      callback(result);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetRejectSetting(callback) {
  axios.get(
    `${Globals.baseUrl}/BulkEdit/GetRejectSetting`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      callback(result);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionChangeReader(query, bulkParam, readerId, defaultId, templateId, changeType, callback) {
  console.log(bulkParam);
  console.log(readerId);
  console.log(defaultId);
  console.log(templateId);
  console.log(changeType);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/UpdateTemplates`,
    {
      query,
      bulk: bulkParam,
      readerId,
      defaultId,
      templateId,
      changeType
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      callback(res.data);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionApproveAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkApproveAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionReject(query, docs, reason, callback) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkReject`,
    {
      docIds: docs,
      query,
      rejectReason: reason
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      callback(res.data);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionRejectAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkRejectAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionDelete(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkDelete`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionDeleteAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkDeleteAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionMoveAndAssign(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkMoveAndAssign`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionMoveAndAssignAll(req) {
  console.log(req);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkMoveAndAssignAll`,
    {
      docIds: req.docIds,
      stepId: req.stepId,
      assignToUserIds: req.assignToUserIds,
      query: req.query,
      parameters: req.params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionMoveAssignAD(req) {
  console.log(req);
  axios.post(
    `${Globals.baseUrl}/ActiveDocument/BulkMoveAssignAD`,
    {
      docIds: req.docIds,
      toStepId: req.toStepId,
      bpId: req.bpId,
      fromStepId: req.fromStepId,
      assignToUserIds: req.assignToUserIds,
      moveType: req.moveType
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionUnassign(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkUnassign`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionUnassignAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkUnassignAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionSendToImageReview(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkSendToImageReview`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionSendToImageReviewAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkSendToImageReviewAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionChangeToReadyStatus(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkChangeToReadyStatus`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionChangeToReadyStatusAll(query, params) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkChangeToReadyAll`,
    {
      query,
      parameters: params
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionChangeTemplate(docs) {
  console.log(docs);
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkChangeTemplate`,
    docs,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionChangeTemplateAll(query) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkChangeTemplateAll`,
    {
      query
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      console.log(result);
      dispatcher.dispatch({
        actionType: actionTypes.BulkAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetWorkflowStepsByBpId(bpId) {
  axios.get(`${Globals.baseUrl}/BulkEdit/GetWorkflowStepsByBpId/${bpId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.WorkflowStepAction,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function BulkActionsDownload(search, docs, callback) {
  axios.post(
    `${Globals.baseUrl}/BulkEdit/BulkDownload`,
    {
      docIds: docs,
      query: search
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      },
      responseType: "blob"
    }
  ).then((res) => {
    if (res.status === 200) {
      var link = document.createElement("a");
      link.setAttribute("download", "");
      let today = /* @__PURE__ */ new Date();
      let year = today.getFullYear();
      let day = today.getDate();
      let month = today.getMonth() + 1;
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = `TrinDocs_BulkDownload_${year}-${month}-${day}.zip`;
      document.body.appendChild(link);
      link.click();
      callback(res.data);
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
